import React from 'react';

import { Progress } from '@betterment/samba-react';
import { ContentLayoutA, Flex, SectionLayout, SiteLayout, theme } from '@betterment/style-closet-react';

import BackLink, { Props as BackLinkProps } from './BackLink';
import Footer from './Footer';
import TakeoverHeader from './TakeoverHeader';

export interface Props {
  children: React.ReactElement | [React.ReactElement, React.ReactElement];
  title: string;
  progressPercent?: number;
  handleBackButton?: BackLinkProps['onClick'];
}

export interface LayoutComponent<P = {}> extends React.FC<P> {
  Slot: React.FC<React.PropsWithChildren<unknown>>;
}

/**
 * @deprecated use one of the shared layout components from `@betterment/retail/src/Shared/layout`
 */
const WorkflowLayout: LayoutComponent<Props> = ({ children, title, progressPercent, handleBackButton }) => {
  let [slot1, slot2] = React.Children.toArray(children) as React.ReactElement[];

  if (!slot2 && slot1.type === React.Fragment) {
    [slot1, slot2] = React.Children.toArray(
      (slot1.props as { children?: React.ReactNode }).children
    ) as React.ReactElement[];
  }

  return (
    <SiteLayout>
      <SiteLayout.Header>
        <SectionLayout py="0" bg="bmtWhite">
          <SectionLayout.ContentWrapper>
            <>
              <TakeoverHeader title={title} />
              {progressPercent !== undefined && (
                <Progress value={progressPercent} indicatorColor="background.neutral.strong" />
              )}
            </>
          </SectionLayout.ContentWrapper>
        </SectionLayout>
      </SiteLayout.Header>
      <SiteLayout.Main>
        <Flex.Item bg="bmtWhite" flex={1}>
          <SectionLayout bg="bmtWhite" py="9">
            <SectionLayout.ContentWrapper>
              <ContentLayoutA>
                <ContentLayoutA.Slot3>
                  {handleBackButton && <BackLink onClick={handleBackButton} />}
                </ContentLayoutA.Slot3>
                <ContentLayoutA.Slot1 px={[0, theme.space[8]]}>{slot1}</ContentLayoutA.Slot1>
                <ContentLayoutA.Slot2 px={[0, theme.space[8]]}>{slot2}</ContentLayoutA.Slot2>
              </ContentLayoutA>
            </SectionLayout.ContentWrapper>
          </SectionLayout>
        </Flex.Item>
      </SiteLayout.Main>
      <SiteLayout.Footer>
        <SectionLayout bg="bmtWhite" py="9">
          <SectionLayout.ContentWrapper>
            <Footer />
          </SectionLayout.ContentWrapper>
        </SectionLayout>
      </SiteLayout.Footer>
    </SiteLayout>
  );
};

export const Slot: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => <>{children}</>;

WorkflowLayout.Slot = Slot;

export default WorkflowLayout;
